/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';
import {theme, paddings} from 'components/shared/theme';

const {colors, mediaPhone} = theme;

export const TopNavigation = styled.default.div<{isLoggedIn: boolean}>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${paddings.medium};
  height: 3.5rem;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  ${({isLoggedIn}) => isLoggedIn && styled.css`
    background-color: ${colors.headerColor};
    padding: ${paddings.small} ${paddings.xlarge};
  `}
`;

export const NavigationLeftSide = styled.default.div`
  display: flex;
  align-items: center;
`;

export const MenuIcon = styled.default.img`
  margin-right: ${paddings.medium};
  width: 1.5rem;
`;

export const User = styled.default.div`
  display: flex;
  align-items: center;
  margin-left: 0;
  color: ${colors.white};

  & div[role="button"] {
    cursor: pointer;
  }
`;

export const ApplicationId = styled.default.p`
  margin: 0;
  padding: 0 ${paddings.small};
`;

export const UserInitials = styled.default.div`
  color: ${colors.white};
  background-color: ${colors.lightBlue};
  display: flex;
  font-weight: bold;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 2.5rem;
  height: 2.5rem;
  text-transform: uppercase;
  ${mediaPhone} {
    display: none;
  }
`;